import React from 'react'
import { Navigate } from 'react-router-dom';
import { useSessionStore } from '../hooks/useSessionStore'


/**
 * If the user is an agencia, show the children, otherwise redirect to the login page
 */
export const Private = ({ children }) => {


    /* Using the useSessionStore hook to get the user from the local storage. */
    const [Usuario, setUsuario] = useSessionStore({});
    
    return (Usuario.tipo !== "noRegistrado")
        ? children
        : <Navigate to="/" />
        
}